// src/modals/DvModal.jsx — modale de saisie d'une dépense variable (compta).
// Champs : libellé, montant, date, payé par (chips), logement concerné optionnel.
// Le sélecteur logement aplatit cfg.props[].logs[] avec propNom pour affichage.

import { useState } from "react"
import { DS } from "../lib/ui"
import { PAYE_PAR_OPTIONS } from "../lib/domain-constants"

import useEchapPourFermer from "../lib/useEchapPourFermer"
export default function DvModal({ dv, cfg, onSave, onClose }) {
  // Échap ferme — consigne 2026-08-14, hook partagé (pile anti-double-fermeture).
  useEchapPourFermer(onClose)

  const [label, setLabel] = useState(dv?.label || "")
  const [montant, setMontant] = useState(String(dv?.montant || ""))
  const [logId, setLogId] = useState(dv?.logId || "")
  const [payePar, setPayePar] = useState(dv?.payePar || "shine")
  const [date, setDate] = useState(dv?.date || new Date().toISOString().split('T')[0])
  const si = { border:`0.5px solid ${DS.borderHover}`,borderRadius:DS.radiusControl,padding:"9px 12px",width:"100%",fontSize:13,outline:"none",fontFamily:DS.fontBody,background:DS.card }
  const lbl = { fontSize:11,color:DS.textMuted,marginBottom:4,fontWeight:600,textTransform:"uppercase",letterSpacing:.5 }
  const allLogs = cfg.props.flatMap(p => p.logs.map(l => ({ ...l, propNom: p.nom })))
  return (
    <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,.55)",zIndex:1000,display:"flex",alignItems:"flex-end",justifyContent:"center"}}>
      <div className="fbz-modal-sheet" style={{background:DS.card,borderRadius:"20px 20px 0 0",padding:24,width:"100%",maxWidth:480,maxHeight:"90vh",overflowY:"auto",fontFamily:DS.fontBody}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
          <div style={{fontFamily:DS.fontDisplay,fontWeight:600,color:DS.marineDark,fontSize:17}}>{dv ? "Modifier" : "Ajouter"} une dépense</div>
          <button onClick={onClose} style={{background:"none",border:"none",fontSize:24,cursor:"pointer",color:DS.textMuted}}>×</button>
        </div>
        <div style={{marginBottom:12}}>
          <div style={lbl}>Libellé</div>
          <input value={label} onChange={e => setLabel(e.target.value)} placeholder="Ex: Essence, Péage, Intervention..." style={si}/>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:12}}>
          <div>
            <div style={lbl}>Montant (€)</div>
            <input type="number" value={montant} onChange={e => setMontant(e.target.value)} placeholder="0.00" style={si}/>
          </div>
          <div>
            <div style={lbl}>Date</div>
            <input type="date" value={date} onChange={e => setDate(e.target.value)} style={si}/>
          </div>
        </div>
        <div style={{marginBottom:12}}>
          <div style={{...lbl,marginBottom:6}}>Payé par</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
            {PAYE_PAR_OPTIONS.map(opt => (
              <button key={opt.value} onClick={() => setPayePar(opt.value)}
                style={{padding:"8px 10px",border:`1.5px solid ${payePar===opt.value?opt.color:DS.border}`,borderRadius:DS.radiusControl,background:payePar===opt.value?opt.color+"15":DS.card,color:payePar===opt.value?opt.color:DS.textMuted,fontWeight:payePar===opt.value?700:500,fontSize:11,cursor:"pointer",fontFamily:DS.fontBody,textAlign:"center"}}>
                {opt.label}
              </button>
            ))}
          </div>
        </div>
        <div style={{marginBottom:20}}>
          <div style={lbl}>Logement concerné <span style={{color:DS.textMuted,textTransform:"none"}}>(optionnel)</span></div>
          <select value={logId} onChange={e => setLogId(e.target.value)} style={si}>
            <option value="">Global (tous logements)</option>
            {allLogs.map(l => <option key={l.id} value={l.id}>{l.nom} — {l.propNom}</option>)}
          </select>
        </div>
        <div style={{display:"flex",gap:8}}>
          <button className="fbz-press" onClick={onClose} style={{flex:1,padding:12,background:DS.card,color:DS.marine,border:`0.5px solid ${DS.borderHover}`,borderRadius:DS.radiusControl,fontWeight:600,cursor:"pointer",fontFamily:DS.fontBody}}>Annuler</button>
          <button className="fbz-press" onClick={() => onSave({ id: dv?.id || null, label, montant: parseFloat(montant) || 0, logId, payePar, date })}
            style={{flex:2,padding:12,background:DS.corail,color:"#fff",border:"none",borderRadius:DS.radiusControl,fontWeight:700,cursor:"pointer",fontFamily:DS.fontBody}}>Enregistrer</button>
        </div>
      </div>
    </div>
  )
}
